import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
  standalone: true
})
export class PhonePipe implements PipeTransform {

  transform(phone: string, mobile: string): string {
    let display = phone ?? mobile;

    if (display === '')
      display = null;

    return display ?? 'Not Set';
  }

}
